var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#479ed5;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.333,16.667H16.667v2.5a.833.833,0,0,1-.833.833H4.167a.833.833,0,0,1-.833-.833v-2.5H1.667A1.669,1.669,0,0,1,0,15V6.667A1.669,1.669,0,0,1,1.667,5H3.333V.833A.833.833,0,0,1,4.167,0H15.833a.833.833,0,0,1,.833.833V5h1.667A1.669,1.669,0,0,1,20,6.667V15A1.669,1.669,0,0,1,18.333,16.667ZM5,18.333H15V12.5H5ZM15,1.667H5V5H15Zm3.333,5H1.667V15H3.333V11.667a.833.833,0,0,1,.833-.833H15.833a.833.833,0,0,1,.833.833V15h1.667Zm-2.5,2.5a.833.833,0,1,1,0-1.667h.833a.833.833,0,0,1,0,1.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterBlue);
export default __webpack_public_path__ + "static/media/printer-blue.d6e3ef9cbb7a107953b6a7dc6382b284.svg";
export { ForwardRef as ReactComponent };